import React, { useEffect, useState, useMemo, useRef } from "react";

import { useNavigate } from "react-router";
import { Row, Col, Button, Form, Container } from "react-bootstrap";
import {
  Title,
  ContainerCupom,
  TitleBrand,
  Line,
  BoxSlider,
  CouponSuccess,
  CouponError,
  DiscountRow,
} from "./styles";
import TextField from "@mui/material/TextField";
import notify from "../../components/UI/toast";
import SliderCheckout from "../../components/SliderCheckout";
import { BrlFormatCurrency, FormatPoints, roundCurrency } from "../../lib";
import { LoaderSmall } from "../../components/Loader";
import CreditCardList from "../../components/CreditCardList";
import { useUserData } from "../../hooks/UserContext";
import TitleHead from "../../components/Title";
import Footer from "../../components/Footer";

import {
  FaRegCheckCircle,
  FaExclamationCircle,
  FaChevronDown,
} from "react-icons/fa";
import SliderCheckoutCoupon from "../../components/SliderCheckoutCoupon";

import { useSelector } from "react-redux";
import { cardsApi, pedidosApi, couponApi, clientesApi } from "./_services/api";
import { getCardBinAndBrand } from "./_utils/card";
import { CouponRulesModal } from "./_components/CouponRulesModal";
import { removeItemCart } from "../../Redux/cartSlice";
import { useDispatch } from "react-redux";
import ProductRow from "./_components/Row/ProductRow";
import { useApp } from "../../contexts/AppContext";
import { useLocation, useSearchParams } from "react-router-dom";
import EmailRequiredModal from "components/GlobalModals/EmailRequiredModal";
import InsufficientPointsModal from "components/GlobalModals/InsufficientPointsModal";
import ModalApp from "../../components/ModalApp";
import { trackHotelPayment } from "utils/analytics";
import { trackResumoCompraEvent, trackViewCartMarketplaceItems, trackAddShippingInfoMarketplaceItems, trackAddPaymentInfoMarketplaceItems, trackPurchaseMarketplaceItems } from "utils/gtm";
import { getCustomerFromMemory, setCustomerInMemory } from "../../lib/sharedSessionMemory";

export default function Product() {
  const [showEmailRequired, setShowEmailRequired] = useState(false);
  const [showInsufficientPoints, setShowInsufficientPoints] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const [loadingCoupon, setLoadingCoupon] = useState(false);
  const [boxNewCard, setBoxNewCard] = useState(false);
  const [cards, setCards] = useState([]);
  const [installmentsSelected, setInstallmentsSelected] = useState();
  const [installments, setInstallments] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [errorCoupon, setErrorCoupon] = useState("");
  const [aplicouCupon, setAplicouCupon] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [dinheiroValue, setDinheiroValue] = useState(0);
  const [pontosValue, setPontosValue] = useState(0);
  const [isLoading, setIsLoading] = useState(null);
  const [closeNewCard, setCloseNewCard] = useState(false);
  const [dataCheckout, setDataCheckout] = useState([]);
  const [itemsCart, setItemsCart] = useState([]);
  const [disableMoneyPayment, setDisableMoneyPayment] = useState("");
  const [refreshCards, setRefreshCards] = useState();
  const [open, setOpen] = useState(false);
  const {
    user,
    addressShipping,
    setUpdateUser,
    mainCard,
    setMainCard,
    cartItemsError,
    setCartItemsError,
    updateUserData, userData, isPJ
  } = useUserData();
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [isValidCoupon, setIsValidCoupon] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rules, setRules] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [errorCode, setErrorCode] = useState("");
  const [isMoneyDisabled, setIsMoneyDisabled] = useState(false);
  const [rulesExpanded, setRulesExpanded] = useState(false);
  const [couponMoneyToPay, setCouponMoneyToPay] = useState(0);
  //const { updateUserData, userData, isPJ } = useUserData();

  const [searchParams] = useSearchParams();
  const [isHotelCheckout, setIsHotelCheckout] = useState(false);
  const [hotelData, setHotelData] = useState(null);
  const [hotelTermsAccepted, setHotelTermsAccepted] = useState(false);
  const [hotelRulesModalOpen, setHotelRulesModalOpen] = useState(false);

  const { loading: loadingCart, payment_method } = useSelector(
    (state) => state.cartSlice,
  );

  const { whitelabel } = useApp();
  const [displayMode, setDisplayMode] = useState(whitelabel?.payment_mode);

  const configData = whitelabel?.config || {};
  const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
  const fatorFreteKey = `fator_${channel}_frete`;
  const fatorFrete = configData[fatorFreteKey] / 10000 || 0;
  const location = useLocation();
  const mainCardRef = useRef(mainCard);
  const cartEventsSent = useRef(false);

  const [minValue, setMinValue] = useState(Number(configData?.[`${channel}_min_value`]) || 0);

  useEffect(() => {
    setDisplayMode(whitelabel?.payment_mode);
  }, [whitelabel]);

  useEffect(() => {
    mainCardRef.current = mainCard;
  }, [mainCard]);

  const productPoints = useMemo(() => {
    return Math.round(
      dataCheckout.cart?.items?.reduce(
        (acc, item) =>
          acc + (item.price?.points?.offer || 0) * (item.quantity || 0),
        0,
      ) || 0,
    );
  }, [dataCheckout.cart?.items]);

  const shippingPoints = useMemo(() => {
    const summaryShippingPoints = parseFloat(
      dataCheckout.summary?.shippingPoints,
    );
    if (summaryShippingPoints > 0) {
      return Math.round(summaryShippingPoints);
    }

    const shippingBRL = parseFloat(dataCheckout.summary?.shipping) || 0;
    if (shippingBRL > 0 && fatorFrete > 0) {
      const factor = 1 / fatorFrete;
      return Math.round(shippingBRL * factor);
    }

    return 0;
  }, [
    dataCheckout.summary?.shippingPoints,
    dataCheckout.summary?.shipping,
    fatorFrete,
  ]);

  const totalPoints = useMemo(() => {
    return productPoints + shippingPoints;
  }, [productPoints, shippingPoints]);

  const discountInPoints = useMemo(() => {
    const discount = parseFloat(dataCheckout.summary?.discount) || 0;
    if (discount <= 0 || fatorFrete <= 0) {
      return 0;
    }
    const factor = 1 / fatorFrete;
    return Math.round(discount * factor);
  }, [dataCheckout.summary?.discount, fatorFrete]);

  const totalPointsWithDiscount = useMemo(() => {
    return Math.max(0, totalPoints - discountInPoints);
  }, [totalPoints, discountInPoints]);

  const ORDER_STATUS = Object.freeze({
    DENIED: "negado",
  });

  useEffect(() => {
    if (mainCard) {
      selecionarParcela(mainCard);
    }
  }, [mainCard]);

  useEffect(() => {
    if (isPJ && !userData.data?.email) {
      setShowEmailRequired(true);
    }
  }, [userData, isPJ]);

  const hasEmail = useMemo(
    () => !!userData.data?.email,
    [userData.data?.email],
  );

  async function getCard() {
    try {
      if (!user?.cpf) {
        console.warn("User CPF not available, skipping card fetch");
        return [];
      }

      const { data, status } = await cardsApi.get(
        `/v1/customer/${user.cpf}/card`,
      );

      if (status !== 200) {
        notify("Erro ao obter os dados do cartão", "error");
        return [];
      }

      return data.data || [];
    } catch (err) {
      console.error(err);
      if (!isHotelCheckout) {
        notify("Erro ao obter os dados do cartão.", "error");
      }
      return [];
    }
  }

  async function getCheckout() {
    if (Object.keys(addressShipping).length === 0) {
      navigate("/loja/orderresume/", { replace: true });
      notify("Selecione o endereço de entrega.", "error");
      return;
    }

    const response = await pedidosApi.get(`v2/checkout/resumo/${channel}`, {
      params: {
        customerUuid: user.uuid,
        cep: user.addresses[0].cep,
        fator: fatorFrete,
      },
    });
    return response.data;
  }

  function getHotelDataFromLocalStorage() {
    try {
      const envisionData = localStorage.getItem("envision");
      if (!envisionData) return null;
      const binaryString = atob(envisionData);
      const uint8Array = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      const decoded = new TextDecoder().decode(uint8Array);
      return JSON.parse(decoded);
    } catch (error) {
      return null;
    }
  }

  async function handleHotelCheckout(checkoutPayload) {
    const response = await pedidosApi.post(
      `v2/checkout/finalizar-pedido/${channel}`,
      checkoutPayload,
    );
    return response;
  }

  function getHotelRoom() {
    if (!hotelData?.hotel?.hotels?.[0]?.rooms?.[0]) return null;
    return hotelData.hotel.hotels[0].rooms[0];
  }

  function getHotel() {
    if (!hotelData?.hotel?.hotels?.[0]) return null;
    return hotelData.hotel.hotels[0];
  }

  function getHotelNights() {
    const room = getHotelRoom();
    if (!room?.checkIn || !room?.checkOut) return 1;

    const checkIn = new Date(
      room.checkIn.year,
      room.checkIn.month - 1,
      room.checkIn.day,
    );
    const checkOut = new Date(
      room.checkOut.year,
      room.checkOut.month - 1,
      room.checkOut.day,
    );
    const diffTime = checkOut.getTime() - checkIn.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 1;
  }

  function getHotelTotalMoney() {
    const room = getHotelRoom();
    if (!room) return 0;
    const nights = getHotelNights();
    const dailyAmount = (room.amount?.BRL || 0) * nights;
    const tax = room.dailyTax?.value || 0;
    return dailyAmount + tax;
  }

  function getHotelTotalPoints() {
    const room = getHotelRoom();
    if (!room) return 0;
    const nights = getHotelNights();
    return (room.amount?.ENVISION || 0) * nights;
  }

  function getHotelDailyPoints() {
    const room = getHotelRoom();
    if (!room) return 0;
    const nights = getHotelNights();
    return (room.amount?.ENVISION || 0) * nights;
  }

  function getHotelTaxPoints() {
    return 0;
  }

  function formatHotelDate(dateObj) {
    if (!dateObj) return "";
    const day = String(dateObj.day).padStart(2, "0");
    const month = String(dateObj.month).padStart(2, "0");
    const year = dateObj.year;
    return `${day}/${month}/${year}`;
  }

  const fetchAndProcessCartData = async () => {
    try {
      const response = await pedidosApi.get(
        `/v2/checkout/resumo/${channel}?customerUuid=${user.uuid}&cep=${addressShipping.cep}&fator=${fatorFrete}`,
      );
      const checkoutData = response.data.data;

      const { allItems, shippingByBrand } = processCartData(checkoutData.cart);

      const formattedCheckoutData = {
        ...checkoutData,
        cart: {
          ...checkoutData.cart,
          items: allItems,
          shipping_by_brand: shippingByBrand,
        },
      };

      return formattedCheckoutData;
    } catch (error) {
      console.error("Erro ao buscar dados do carrinho:", error);
      throw error;
    }
  };

  const processCartData = (cartData) => {
    const allItems = [];
    const shippingByBrand = {};

    if (cartData.items && Array.isArray(cartData.items)) {
      allItems.push(...cartData.items);

      if (dataCheckout.cart?.shipping_by_brand) {
        Object.assign(shippingByBrand, dataCheckout.cart.shipping_by_brand);
      }

      return { allItems, shippingByBrand };
    }

    Object.values(cartData || {}).forEach((cartInfo) => {
      if (cartInfo.items) {
        allItems.push(...cartInfo.items);

        cartInfo.items.forEach((item) => {
          const brandId = item.brand_uuid;
          if (!shippingByBrand[brandId]) {
            shippingByBrand[brandId] = {
              shipping_amount: cartInfo.deliveryOptions?.shippingPrice || 0,
              shipping_point: cartInfo.deliveryOptions?.shippingPoints || 0,
              shipping_deadline:
                cartInfo.deliveryOptions?.estimatedBusinessDays || 0,
            };
          }
        });
      }
    });

    return { allItems, shippingByBrand };
  };

  async function setCartPedidosApi(items) {
    setCartItemsError({});
    if (addressShipping?.cep && user.uuid) {
      setLoading(true);

      try {
        const formattedCheckoutData = await fetchAndProcessCartData();

        setDataCheckout(formattedCheckoutData);

        const grouped = await groupItemsSeller(
          formattedCheckoutData.cart.items,
        );
        setItemsCart(grouped);
      } catch (error) {
        console.error("Erro em setCartPedidosApi:", error);
        notify("Erro ao carregar dados do carrinho", "error");
      } finally {
        setLoading(false);
      }
    }
  }

  function groupByKey(array, prop) {
    return array.reduce(function (items, item) {
      const key = item[prop];
      items[key] = (items[key] || []).concat(item);
      return items;
    }, {});
  }

  const groupItemsSeller = async (array) => {
    if (array) {
      const items = array.map((item) => ({
        ...item,
        seller: item?.seller,
        brand_uuid: item?.brand_uuid,
      }));
      return groupByKey(items, "seller");
    }
  };

  const getShippingPointsValue = () => {
    const summaryShippingPoints = parseFloat(
      dataCheckout?.summary?.shippingPoints,
    );
    if (summaryShippingPoints > 0) {
      return Math.round(summaryShippingPoints);
    }
    const shippingBRL = parseFloat(dataCheckout?.summary?.shipping) || 0;
    if (shippingBRL > 0 && fatorFrete > 0) {
      const factor = 1 / fatorFrete;
      return Math.round(shippingBRL * factor);
    }
    return 0;
  };

  function calcularMaxSliderValue() {
    if (!dataCheckout?.cart || !user?.balance?.data) return 100;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const shippingPts = getShippingPointsValue();
    const totalPoints = Math.round(pontosBase + shippingPts);

    if (totalPoints === 0) return 100;

    const balance = Math.trunc(user.balance.data);

    if (balance >= totalPoints) return 0;

    const maxPctDinheiro = ((totalPoints - balance) / totalPoints) * 100;

    return Math.min(Math.max(maxPctDinheiro, 0), 100);
  }

  function calcularMaxSliderValueForMinPoints() {
    if (!dataCheckout?.cart || !minValue || minValue <= 0) return 100;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const shippingPts = getShippingPointsValue();
    const totalPoints = Math.round(pontosBase + shippingPts);

    if (totalPoints === 0) return 100;

    if (minValue >= totalPoints) return 0;

    const maxSliderForMinPoints =
      ((totalPoints - minValue) / totalPoints) * 100;

    return Math.min(Math.max(maxSliderForMinPoints, 0), 100);
  }

  function getPaymentType(moneyValue, pointsValue) {
    if (moneyValue > 0 && pointsValue > 0) return "cartao-de-credito+pontos";
    if (moneyValue > 0) return "cartao-de-credito";
    return "pontos";
  }

  const paymentInfoTimer = useRef(null);
  function handlePaymentInfoChange(moneyValue, pointsValue) {
    if (paymentInfoTimer.current) clearTimeout(paymentInfoTimer.current);
    paymentInfoTimer.current = setTimeout(() => {
      trackAddPaymentInfoMarketplaceItems(dataCheckout.cart?.items || [], getPaymentType(moneyValue, pointsValue));
    }, 500);
  }

  function handleSliderChange(event, newValue) {
    if (!dataCheckout?.cart) return;

    const maxSliderValueByBalance = calcularMaxSliderValue();

    const maxSliderValueByMinPoints = calcularMaxSliderValueForMinPoints();

    const maxSliderValue = Math.max(
      maxSliderValueByBalance,
      maxSliderValueByMinPoints,
    );

    if (newValue < maxSliderValueByBalance) {
      setSliderValue(maxSliderValueByBalance);
      calcularDinheiroPontos(maxSliderValueByBalance);

      const balance = Math.trunc(user?.balance?.data ?? 0);
      const balanceFormatted = balance.toLocaleString("pt-BR");
      notify(
        `Não é possível selecionar mais pontos. Você possui ${balanceFormatted} pontos disponíveis. O valor máximo foi ajustado automaticamente.`,
        "warning",
      );
      return;
    }

    if (newValue > maxSliderValueByMinPoints && minValue > 0) {
      setSliderValue(maxSliderValueByMinPoints);
      calcularDinheiroPontos(maxSliderValueByMinPoints);

      const MinValueFormatted = minValue.toLocaleString("pt-BR");
      notify(
        `É necessário selecionar pelo menos ${MinValueFormatted} pontos. O valor mínimo foi ajustado automaticamente.`,
        "warning",
      );
      return;
    }

    setSliderValue(newValue);
    calcularDinheiroPontos(newValue);
  }

  function calcularDinheiroPontos(range) {
    if (!dataCheckout?.cart) return;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const reaisBase = items.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item?.price?.BRL?.offer ?? 0) || 0) * (item?.quantity ?? 0),
      0,
    );

    const shippingMoney = parseFloat(dataCheckout?.summary?.shipping) || 0;
    const shippingPts = getShippingPointsValue();
    const descontoMoney = parseFloat(dataCheckout?.summary?.discount) || 0;

    const reaisTotais = reaisBase + shippingMoney - descontoMoney;
    const pontosTotais = Math.round(pontosBase + shippingPts);

    const fracDinheiro = (Number(range) || 0) / 100;

    let dinheiroParcial = reaisTotais * fracDinheiro;
    let pontosParcial = pontosTotais * (1 - fracDinheiro);

    const balance = Math.trunc(user?.balance?.data ?? 0);

    if (pontosParcial > balance && pontosTotais > 0) {
      const pontosExcedentes = pontosParcial - balance;

      const taxaConversao = reaisTotais / pontosTotais;
      const reaisAdicionais = pontosExcedentes * taxaConversao;
      dinheiroParcial = dinheiroParcial + reaisAdicionais;
      pontosParcial = balance;
    }

    const wasEnforcedToMin =
      minValue > 0 && pontosParcial < minValue && pontosTotais >= minValue;
    if (wasEnforcedToMin) {
      pontosParcial = Math.min(minValue, pontosTotais);
      const taxaConversao = reaisTotais / pontosTotais;
      dinheiroParcial = (pontosTotais - pontosParcial) * taxaConversao;
    }

    if (!wasEnforcedToMin) {
      pontosParcial = Math.round(pontosParcial);
    } else {
      pontosParcial = Math.trunc(pontosParcial);
    }

    setDinheiroValue(roundCurrency(dinheiroParcial));
    setPontosValue(pontosParcial);
  }

  function exibirDinheiroPontosPagar(range) {
    if (!dataCheckout?.cart || dataCheckout?.cart?.items.length === 0) return;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const reaisBase = items.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item?.price?.BRL?.offer ?? 0) || 0) * (item?.quantity ?? 0),
      0,
    );

    const shippingMoney = parseFloat(dataCheckout?.summary?.shipping) || 0;
    const shippingPts = getShippingPointsValue();
    const descontoMoney = parseFloat(dataCheckout?.summary?.discount) || 0;

    const totalMoney = reaisBase + shippingMoney - descontoMoney;
    const totalPoints = Math.round(pontosBase + shippingPts);

    let currentRange = Math.min(Math.max(Number(range) || 0, 0), 100);

    const balance = Math.trunc(user?.balance?.data ?? 0);
    const maxSliderValueByBalance = calcularMaxSliderValue();
    const maxSliderValueByMinPoints = calcularMaxSliderValueForMinPoints();

    if (payment_method === "pontos") {
      if (currentRange < maxSliderValueByBalance) {
        currentRange = maxSliderValueByBalance;
        setSliderValue(currentRange);
      }

      if (currentRange > maxSliderValueByMinPoints && minValue > 0) {
        currentRange = maxSliderValueByMinPoints;
        setSliderValue(currentRange);
      }
    }

    const fracDinheiro = currentRange / 100;
    let dinheiroParcial = totalMoney * fracDinheiro;
    let pontosParcial = totalPoints * (1 - fracDinheiro);

    if (pontosParcial > balance && totalPoints > 0) {
      const pontosExcedentes = pontosParcial - balance;

      const taxaConversao = totalMoney / totalPoints;
      const reaisAdicionais = pontosExcedentes * taxaConversao;
      dinheiroParcial = dinheiroParcial + reaisAdicionais;
      pontosParcial = balance;
    }

    const wasEnforcedToMin =
      minValue > 0 && pontosParcial < minValue && totalPoints >= minValue;
    if (wasEnforcedToMin) {
      pontosParcial = Math.min(minValue, totalPoints);
      const taxaConversao = totalMoney / totalPoints;
      dinheiroParcial = (totalPoints - pontosParcial) * taxaConversao;
    }

    if (!wasEnforcedToMin) {
      pontosParcial = Math.round(pontosParcial);
    } else {
      pontosParcial = Math.trunc(pontosParcial);
    }

    setDinheiroValue(roundCurrency(dinheiroParcial || 0));
    setPontosValue(pontosParcial);
  }

  function lockSlider() {
    setSliderValue(100);
    setAplicouCupon(true);
  }

  const effectiveMoneyToPay = useMemo(() => {
    if (isCouponApplied) {
      return couponMoneyToPay;
    } else {
      return parseFloat(dinheiroValue || 0);
    }
  }, [isCouponApplied, couponMoneyToPay, dinheiroValue]);

  const normalizePercentage = (value) => {
    if (value === null || value === undefined) return 0;

    let cleaned = String(value)
        .replace('%', '')
        .replace(',', '')
        .trim();

    let num = Number(cleaned);

    if (isNaN(num)) return 0;

    if (num > 100) {
        num = num / 100;
    }

    return num;
  }

  useEffect(() => {
    if (dataCheckout.summary?.coupon) {
      lockSlider();
    }
    exibirDinheiroPontosPagar(sliderValue);
    typeof mainCard !== "undefined" && selecionarParcela(mainCard);
    setInstallmentsSelected("");
    setInstallments([]);

    effectiveMoneyToPay == 0
      ? setDisableMoneyPayment("disable")
      : setDisableMoneyPayment("");

    if (isCouponApplied) {
      setDinheiroValue(couponMoneyToPay);
    } else {
      setDinheiroValue(dinheiroValue);
    }
  }, [dataCheckout, effectiveMoneyToPay]);

  useEffect(() => {
    if (
      payment_method === "pontos" ||
      (payment_method === "both" && effectiveMoneyToPay <= 0)
    ) {
      setIsMoneyDisabled(true);
    } else {
      setIsMoneyDisabled(false);
    }

    if (effectiveMoneyToPay > 0) {
      setDisableMoneyPayment("");
    } else {
      setDisableMoneyPayment("disable");
    }
  }, [payment_method, effectiveMoneyToPay]);

  useEffect(() => {
    if (mainCard && dinheiroValue > 0 && aplicouCupon) {
      selecionarParcela(mainCard);
    }
  }, [dinheiroValue, mainCard, aplicouCupon]);

  async function setDefaultMainCard(cardsUser) {
    const mainCard = cardsUser.filter((card) => card.main === true);
    if (mainCard && mainCard.length) {
      setMainCard(mainCard[0]);
      return;
    }

    if (cardsUser && cardsUser.length) {
      setMainCard(cardsUser[0]);
    }
  }

  useEffect(() => {
    const checkoutParam = searchParams.get("checkout");
    if (checkoutParam === "hotel") {
      const hotelInfo = getHotelDataFromLocalStorage();
      if (hotelInfo) {
        setIsHotelCheckout(true);
        setHotelData(hotelInfo);
      } else {
        notify("Dados da reserva de hotel não encontrados.", "error");
        navigate("/loja/");
      }
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const checkoutParam = searchParams.get("checkout");
      const isHotelMode = checkoutParam === "hotel" || isHotelCheckout;

      if (isHotelMode) {
        let currentHotelData = hotelData;
        if (!currentHotelData) {
          currentHotelData = getHotelDataFromLocalStorage();
          if (currentHotelData) {
            setIsHotelCheckout(true);
            setHotelData(currentHotelData);
          } else {
            notify("Dados da reserva de hotel não encontrados.", "error");
            navigate("/loja/");
            return;
          }
        }

        let cardsUser = [];
        try {
          cardsUser = (await getCard()) || [];
        } catch (err) {
          console.warn("Could not fetch cards for hotel checkout:", err);
        }
        setCards(cardsUser);
        if (cardsUser.length > 0) {
          await setDefaultMainCard(cardsUser);
        }

        const days = currentHotelData.datesSearchHotel?.days || 1;
        const dailyAmount = (currentHotelData.room?.amount?.BRL || 0) * days;
        const tax = currentHotelData.room?.dailyTax?.BRL || 0;
        const totalMoney = dailyAmount + tax;

        const hotelCheckoutData = {
          cart: {
            items: [],
            shipping_by_brand: {},
          },
          summary: {
            total: totalMoney,
            shipping: 0,
            shippingPoints: 0,
            discount: 0,
            coupon: null,
          },
        };
        setDataCheckout(hotelCheckoutData);
        setLoading(false);
        return;
      }

      const checkoutResponse = await getCheckout();
      const checkoutData = checkoutResponse?.data || checkoutResponse;
      const cardsUser = await getCard();

      setCards(cardsUser);
      await setDefaultMainCard(cardsUser);

      const { allItems, shippingByBrand } = processCartData(
        checkoutData?.cart || {},
      );
      const formattedCheckoutData = {
        ...checkoutData,
        cart: {
          ...(checkoutData?.cart || {}),
          items: allItems,
          shipping_by_brand: shippingByBrand,
        },
      };

      const grouped = await groupItemsSeller(allItems);
      setItemsCart(grouped);
      setDataCheckout(formattedCheckoutData);

      if (!cartEventsSent.current) {
        trackViewCartMarketplaceItems(allItems);
        trackAddShippingInfoMarketplaceItems(allItems, formattedCheckoutData.cart?.shipping_by_brand);
        cartEventsSent.current = true;
      }

      const couponInfo = formattedCheckoutData?.summary?.coupon;
      if (couponInfo) {
        const couponCode = couponInfo.code || couponInfo.name;
        setCoupon(couponCode);
        setIsValidCoupon(true);
        setIsCouponApplied(true);
        setRules(couponInfo.rules || "");
        setErrorTitle("");
        setErrorDescription("");
        setErrorCoupon("");
      } else {
        setIsCouponApplied(false);
        setIsValidCoupon(null);
      }

      setLoading(false);
    };

    const checkoutParam = searchParams.get("checkout");
    if (checkoutParam === "hotel" || user) {
      fetchData();
    }
  }, [user, refreshCards, isHotelCheckout, searchParams]);

  useEffect(() => {
    if (isCouponApplied) {
      return;
    }

    if (
      displayMode === "both" ||
      (displayMode === "points" && dataCheckout.cart)
    ) {
      let balance = Math.trunc(user?.balance?.data);

      let pontosBase = dataCheckout.cart.items.reduce(
        (acc, item) => acc + (item.price.points?.offer || 0) * item.quantity,
        0,
      );
      let reaisBase = dataCheckout.cart.items.reduce(
        (acc, item) =>
          acc + parseFloat(item.price.BRL?.offer || 0) * item.quantity,
        0,
      );

      let shipping = parseFloat(dataCheckout.summary?.shipping || 0);
      let shippingPts = getShippingPointsValue();
      let desconto = parseFloat(dataCheckout.summary?.discount || 0);
      let pontosTotais = Math.round(pontosBase + shippingPts);
      let reaisTotais = reaisBase + shipping - desconto;

      let initialRange = 0;
      if (balance >= pontosTotais) {
        initialRange = 0;
      } else {
        initialRange = ((pontosTotais - balance) / pontosTotais) * 100;
      }
      initialRange = Math.min(initialRange, 100);

      const maxSliderValueByMinPoints = calcularMaxSliderValueForMinPoints();
      if (initialRange > maxSliderValueByMinPoints && minValue > 0) {
        initialRange = maxSliderValueByMinPoints;
      }

      setSliderValue(initialRange);

      let range = initialRange / 100;
      let dinheiroParcial = reaisTotais * range;
      let pontosParcial = pontosTotais * (1 - range);

      if (pontosParcial > balance && pontosTotais > 0) {
        const pontosExcedentes = pontosParcial - balance;
        const taxaConversao = reaisTotais / pontosTotais;
        const reaisAdicionais = pontosExcedentes * taxaConversao;
        dinheiroParcial = dinheiroParcial + reaisAdicionais;
        pontosParcial = balance;
      }

      const wasEnforcedToMin =
        minValue > 0 && pontosParcial < minValue && pontosTotais >= minValue;
      if (wasEnforcedToMin) {
        pontosParcial = Math.min(minValue, pontosTotais);
        const taxaConversao = reaisTotais / pontosTotais;
        dinheiroParcial = (pontosTotais - pontosParcial) * taxaConversao;
        initialRange = ((pontosTotais - pontosParcial) / pontosTotais) * 100;
        setSliderValue(Math.min(Math.max(initialRange, 0), 100));
      }

      if (!wasEnforcedToMin) {
        pontosParcial = Math.round(pontosParcial);
      } else {
        pontosParcial = Math.trunc(pontosParcial);
      }

      setDinheiroValue(roundCurrency(dinheiroParcial));
      setPontosValue(pontosParcial);
    }
  }, [dataCheckout.cart, payment_method, user?.balance?.data, displayMode]);

  useEffect(() => {
    if (!isCouponApplied || !dataCheckout.summary?.coupon) {
      return;
    }

    const balance = Math.trunc(user?.balance?.data || 0);
    const factor = fatorFrete > 0 ? 1 / fatorFrete : 1;
    const totalAfterCoupon = parseFloat(dataCheckout.summary?.total || 0);
    const discount = parseFloat(dataCheckout.summary?.discount || 0);
    const discountInPts = Math.round(discount * factor);
    const totalPointsWithCoupon = Math.max(0, totalPoints - discountInPts);

    let pontosParcial = totalPointsWithCoupon;
    let dinheiroParcial = 0;

    if (pontosParcial > balance && totalPointsWithCoupon > 0) {
      pontosParcial = balance;
      const pointsInMoney = pontosParcial / factor;
      dinheiroParcial = totalAfterCoupon - pointsInMoney;
    }

    if (
      minValue > 0 &&
      pontosParcial < minValue &&
      totalPointsWithCoupon >= minValue
    ) {
      pontosParcial = Math.min(minValue, totalPointsWithCoupon);
      const pointsInMoney = pontosParcial / factor;
      dinheiroParcial = totalAfterCoupon - pointsInMoney;
    }

    setPontosValue(pontosParcial);
    setDinheiroValue(roundCurrency(dinheiroParcial));
    setCouponMoneyToPay(dinheiroParcial);
  }, [
    isCouponApplied,
    dataCheckout.summary,
    user?.balance?.data,
    fatorFrete,
    minValue,
    totalPoints,
  ]);

  useEffect(() => {
    if (isHotelCheckout && hotelData) {
      const totalMoney = getHotelTotalMoney();
      const totalPoints = getHotelTotalPoints();
      const balance = Math.trunc(user?.balance?.data || 0);

      let initialRange = 0;
      if (balance >= totalPoints) {
        initialRange = 0;
      } else {
        initialRange = Math.min(
          ((totalPoints - balance) / totalPoints) * 100,
          100,
        );
      }

      setSliderValue(initialRange);

      const range = initialRange / 100;
      let dinheiroParcial = totalMoney * range;
      let pontosParcial = totalPoints * (1 - range);

      if (pontosParcial > balance && totalPoints > 0) {
        const pontosExcedentes = pontosParcial - balance;
        const taxaConversao = totalMoney / totalPoints;
        const reaisAdicionais = pontosExcedentes * taxaConversao;
        dinheiroParcial = dinheiroParcial + reaisAdicionais;
        pontosParcial = balance;
      }

      setDinheiroValue(roundCurrency(dinheiroParcial));
      setPontosValue(Math.round(pontosParcial));
    }
  }, [isHotelCheckout, hotelData, user?.balance?.data]);

  useEffect(() => {
    if (isHotelCheckout) {
      const total = getHotelTotalPoints();
      const minimumPercentage = normalizePercentage(configData?.percentual_minimo_pagamento_pontos)
      const minPointsPercentage = parseInt((total * minimumPercentage) / 100)
      const minPaymentPoints = normalizePercentage(configData?.valor_minimo_pontos_utilizado_compra)

      setMinValue(Math.max(minPointsPercentage, minPaymentPoints));
      return;
    }

    setMinValue(Number(configData?.[`${channel}_min_value`]) || 0)
  }, [isHotelCheckout, hotelData, configData]);

  useEffect(() => {
    if (dataCheckout.summary?.coupon && payment_method === "pontos") {
      removeCoupon();
    }
  }, [dataCheckout, payment_method]);

  const isCouponAppliedRef = useRef(isCouponApplied);
  useEffect(() => {
    isCouponAppliedRef.current = isCouponApplied;
  }, [isCouponApplied]);

  useEffect(() => {
    return () => {
      if (isCouponAppliedRef.current) {
        couponApi
          .post(`/api/coupon/remove/${channel}`, {
            customerUuid: user?.uuid,
            cep: addressShipping?.cep,
          })
          .catch(() => {});
      }
    };
  }, [channel, user?.uuid, addressShipping?.cep]);

  useEffect(() => {
    return () => {
      setInstallments([]);
      setInstallmentsSelected("");

      const currentMainCard = mainCardRef.current;

      if (currentMainCard && !currentMainCard.uuid) {
        setMainCard(null);
      }
    };
  }, [location.pathname, setMainCard]);

  const saveNewCard = async (values, card_hash) => {
    const last_digits = values.card_number?.substr(-4);
    const { bin, brand } = getCardBinAndBrand(values.card_number);
    const expirationMonth = values.card_expiration_date.split("/")[0];
    const expirationYear = values.card_expiration_date.split("/")[1];
    const createdCard = {
      brand: brand,
      bin: bin,
      expiration_month: expirationMonth,
      expiration_year: expirationYear,
      holder_cpf: values.card_document,
      holder_name: values.card_holder_name,
      last_four_digits: last_digits,
      main: false,
      hash: card_hash,
    };

    if (!values.card_save) {
      setCards([createdCard, ...cards]);

      setTimeout(() => {
        setMainCard(createdCard);
        setCloseNewCard(true);
      }, 800);
      setCloseNewCard(true);
    }

    try {
      if (values.card_save) {
        const payload = {
          cardToken: card_hash,
          bin: createdCard.bin,
          brand: createdCard.brand,
          expirationMonth: createdCard.expiration_month,
          expirationYear: createdCard.expiration_year,
          holderName: createdCard.holder_name,
          lastFourDigits: createdCard.last_four_digits,
          main: cards.length >= 1 ? false : true,
        };

        setIsLoading(true);
        const { data, status } = await cardsApi.post(
          `/v1/customer/${user.cpf}/card`,
          payload,
        );

        if (status !== 200) {
          notify("Erro ao cadastrar o cartão", "error");
          return;
        }

        notify("Cartão cadastrado com sucesso.", "success");

        createdCard.uuid = data?.data.uuid;

        setCards([createdCard, ...cards]);
        setMainCard(createdCard);
        setCloseNewCard(true);
      }
    } catch (error) {
      notify("Erro ao cadastrar o cartão", "error");
      console.error(error);
    } finally {
      setIsLoading(false);
      setCloseNewCard(true);
    }

    setTimeout(() => {
      setCloseNewCard(true);
    }, 800);
    setCloseNewCard(true);
  };

  async function getInstallments(customerUuid, totalAmount, type = "produto") {
    return await pedidosApi.get(`v1/installment/options/${channel}`, {
      params: {
        customerUuid: customerUuid,
        amount: totalAmount,
        installmentType: type,
      },
    });
  }

  async function selecionarParcela(card) {
    let valorTotal = parseFloat(dinheiroValue);

    if (isNaN(valorTotal)) {
      return;
    }

    if (card && card.last_four_digits) {
      setDisableMoneyPayment("disable");
      const installmentType = isHotelCheckout ? "hotel" : "produto";
      const result = await getInstallments(
        user.uuid,
        valorTotal,
        installmentType,
      );
      if (dinheiroValue > 0) {
        setInstallments(Object.values(result.data.data));
        setDisableMoneyPayment("");
      }
    }
  }

  const ERROR_MESSAGES = Object.freeze({
    COUPON_NOT_APPLICABLE: {
      title: "Cupom não aplicado.",
      message: "O cupom não é válido para nenhum item do seu carrinho.",
    },
    COUPON_EXPIRED: {
      title: "Cupom vencido.",
      message: "O período para utilização deste cupom foi encerrado.",
    },
    COUPON_OUT_OF_STOCK: {
      title: "Cupom esgotado.",
      message: "Todos os cupons disponíveis já foram utilizados.",
    },
    COUPON_INACTIVE: {
      title: "Cupom esgotado.",
      message: "Todos os cupons disponíveis já foram utilizados.",
    },
    INVALID_COUPON: {
      title: "Cupom inválido.",
      message: "O cupom não é válido ou já foi utilizado.",
    },
    GENERIC_ERROR: {
      title: "Cupom não aplicado.",
      message: "Ocorreu um erro ao aplicar o cupom.",
    },
  });

  function getErrorMessage(code) {
    return ERROR_MESSAGES[code];
  }

  async function applyCoupon() {
    trackResumoCompraEvent({ title: "aplicar-cupom" });
    setLoadingCoupon(true);

    try {
      const { data, status } = await couponApi.post(
        `/api/coupon/apply/${channel}`,
        {
          customerUuid: user.uuid,
          cep: addressShipping.cep,
          coupon: coupon,
          fator: fatorFrete,
        },
      );

      const responseData = data?.data;

      if (status === 200 && responseData) {
        const summary = responseData.summary || {};
        const couponInfo = summary.coupon || {};
        const { allItems, shippingByBrand } = processCartData(
          responseData.cart || {},
        );
        const formattedCheckoutData = {
          ...responseData,
          cart: {
            ...(responseData.cart || {}),
            items: allItems,
            shipping_by_brand: shippingByBrand,
          },
        };
        const grouped = await groupItemsSeller(allItems);
        setItemsCart(grouped);
        setDataCheckout(formattedCheckoutData);
        setRules(couponInfo.rules || "");
        setCoupon(couponInfo.code || coupon);

        const totalPayment = Number(summary.total) || 0;
        setDinheiroValue(roundCurrency(totalPayment));

        setErrorCoupon("");
        setIsValidCoupon(true);
        lockSlider();
        notify(
          couponInfo.message ||
            `O cupom ${couponInfo.code || coupon} foi aplicado.`,
          "success",
        );
        setIsCouponApplied(true);
      } else {
        const errorData = getErrorMessage(data?.code);
        setErrorCoupon("Falha ao aplicar cupom");
        setIsValidCoupon(false);
        setIsCouponApplied(false);
        setRules(data?.rules);
        setErrorCode(data?.code || "");
        setErrorTitle(errorData?.title || "Cupom não aplicado.");
        setErrorDescription(
          errorData?.message || "Ocorreu um erro ao aplicar o cupom.",
        );
      }
    } catch (e) {
      const responseData = e?.response?.data;
      const errorData = getErrorMessage(responseData?.code);

      setErrorCoupon("Falha ao aplicar cupom");
      setIsValidCoupon(false);
      setIsCouponApplied(false);

      setRules(responseData?.rules);
      setErrorCode(responseData?.code || "");
      setErrorTitle(errorData?.title || "Cupom não aplicado.");
      setErrorDescription(
        errorData?.message || "Ocorreu um erro ao aplicar o cupom.",
      );
    } finally {
      setLoadingCoupon(false);
    }
  }

  async function removeCoupon(shouldNotify = true) {
    trackResumoCompraEvent({ title: "excluir-cupom" });
    setLoadingCoupon(true);

    try {
      await couponApi.post(`/api/coupon/remove/${channel}`, {
        customerUuid: user.uuid,
        cep: addressShipping.cep,
      });

      setCoupon("");
      setAplicouCupon(false);
      setIsCouponApplied(false);
      setCouponMoneyToPay(0);
      setIsValidCoupon(null);
      setErrorTitle("");
      setErrorDescription("");
      setErrorCoupon("");
      setErrorCode("");
      setRules("");
      setRulesExpanded(false);

      const formattedCheckoutData = await fetchAndProcessCartData();
      setDataCheckout(formattedCheckoutData);

      const grouped = await groupItemsSeller(formattedCheckoutData.cart.items);
      setItemsCart(grouped);

      if (shouldNotify) {
        notify(`O cupom foi removido.`, "success");
      }
    } catch (e) {
      if (shouldNotify) {
        notify("Erro ao remover cupom.", "error");
      }
    } finally {
      setLoadingCoupon(false);
    }
  }

  async function HandleFinished() {
    trackResumoCompraEvent({ title: "finalizar-compra" });
    const effectiveMoneyToPay = isCouponApplied
      ? couponMoneyToPay
      : parseFloat(dinheiroValue || 0);

    const userBalance = Math.trunc(user?.balance?.data || 0);
    if (minValue > 0 && userBalance < minValue) {
      setShowInsufficientPoints(true);
      return;
    }

    if (effectiveMoneyToPay > 0) {
      if (!mainCard)
        return notify("Informe o cartão para o pagamento.", "error");
      if (!installmentsSelected)
        return notify("Selecione a quantidade de parcelas.", "error");
    }
    setLoadingCheckout(true);

    if (isHotelCheckout && hotelData) {
      try {
        const room = getHotelRoom();
        const hotel = getHotel();
        const nights = getHotelNights();
        const fixedTravellers = (hotelData.travellers || []).map(
          (traveller) => ({
            ...traveller,
            documents: (traveller.documents || []).map((doc) => {
              const { documenType, ...rest } = doc;
              return {
                ...rest,
                documentType: doc.documentType || documenType,
              };
            }),
          }),
        );

        const sanitizedHotel = {
          ...hotelData.hotel,
          hotels: (hotelData.hotel?.hotels || []).map((hotel) => ({
            ...hotel,
            description: hotel.description || hotel.name || "",
            address: hotel.address
              ? {
                  ...hotel.address,
                  longitude: String(hotel.address.longitude || ""),
                  latitude: String(hotel.address.latitude || ""),
                }
              : hotel.address,
            rooms: (hotel.rooms || []).map((room) => ({
              ...room,
              description: room.description || room.name || "",
              dailyFare: room.dailyFare || { value: 0, currencyCode: "BRL" },
              markedupDailyFare: room.markedupDailyFare ||
                room.dailyFare || { value: 0, currencyCode: "BRL" },
              originalDailyFare: room.originalDailyFare ||
                room.dailyFare || { value: 0, currencyCode: "BRL" },
              dailyTax: room.dailyTax || { value: 0, currencyCode: "BRL" },
              originalDailyTax: room.originalDailyTax ||
                room.dailyTax || { value: 0, currencyCode: "BRL" },
              dailyFareDiscount: room.dailyFareDiscount || { value: 0 },
            })),
          })),
        };

        const hotelTotalPoints = getHotelTotalPoints();
        const hotelTotalMoney = getHotelTotalMoney();
        const finalPontosValue =
          pontosValue > 0 ? pontosValue : hotelTotalPoints;
        const finalMoneyValue =
          effectiveMoneyToPay > 0 ? effectiveMoneyToPay : 0;

        const paymentLabel =
          finalPontosValue > 0 && finalMoneyValue > 0
            ? "Pontos + Cartao"
            : finalPontosValue > 0
              ? "Pontos"
              : "Cartao";

        if (room && hotel) {
          trackHotelPayment({
            hotel_name: hotel?.name,
            room_name: room?.name,
            points: finalPontosValue,
            cash: finalMoneyValue,
            total_value: hotelTotalMoney,
            total_points: hotelTotalPoints,
            check_in: formatHotelDate(room.checkIn),
            check_out: formatHotelDate(room.checkOut),
            payment: paymentLabel,
            nights,
            stars: hotel?.stars,
            hosts: (hotelData?.travellers || []).length,
          });
        }

        let paymentType = "CREDIT";
        if (finalPontosValue > 0 && finalMoneyValue > 0) {
          paymentType = "BOTH";
        } else if (finalPontosValue > 0 && finalMoneyValue <= 0) {
          paymentType = "POINTS";
        }

        const hotelCheckoutPayload = {
          orderType: "hotel",
          customerData: {
            pagarmeId: null,
            customerUuid: hotelData.customerId || user.uuid,
            createdAt: user.created_at
              ? new Date(user.created_at).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            firstName: user.nome,
            lastName: user.sobrenome,
            cpf: user.cpf,
            email: user.email,
            phones: {
              number: user.telefone,
            },
            address: {
              addressUuid: addressShipping.uuid,
              streetName: addressShipping.address_line1,
              complement: addressShipping.address_line3,
              neighborhood: addressShipping.address_line2,
              number: addressShipping.number,
              cep: addressShipping.cep,
              city: addressShipping.city,
              state: addressShipping.state,
              reference: addressShipping.reference,
            },
          },
          travellers: fixedTravellers,
          hotel: sanitizedHotel,
          totalAmount: finalMoneyValue || hotelTotalMoney,
          points: finalPontosValue,
          paymentPoints: {
            amount: finalPontosValue,
            fator: 1,
          },
          paymentBRL: {
            type: paymentType,
            amount: finalMoneyValue,
            installments: installmentsSelected || 1,
            save: false,
            mainCard: false,
            cardUuid: mainCard?.uuid || null,
            gatewayCardKey: mainCard?.hash || null,
          },
        };

        const response = await handleHotelCheckout(hotelCheckoutPayload);
        const orderUuid = response.data?.data?.orderUuid;

        if (orderUuid) {
          const authorizeOrder = await pedidosApi.post(
            `v1/pedidos/${channel}/authorization/` + orderUuid,
            {
              authorized: true,
            },
          );

          if (
            authorizeOrder?.data?.data?.status?.toLowerCase() ===
            ORDER_STATUS.DENIED
          ) {
            navigate(`/loja/ordernotapproved`);
            return;
          }

          const balance = await clientesApi.get(`customer/${user.cpf}/balance`);

          const userData = getCustomerFromMemory();
          if (userData) {
            userData.data.balance = {
              data: balance.data.data,
            };
            setCustomerInMemory(userData);

            updateUserData();
          }

          if (room && hotel) {
            const bookingPayload = {
              order_id: orderUuid,
              hotel_name: hotel?.name,
              room_name: room?.name,
              points: finalPontosValue,
              cash: finalMoneyValue,
              total_value: hotelTotalMoney,
              total_points: hotelTotalPoints,
              check_in: formatHotelDate(room.checkIn),
              check_out: formatHotelDate(room.checkOut),
              payment: paymentLabel,
              nights,
              stars: hotel?.stars,
              hosts: (hotelData?.travellers || []).length,
            };

            localStorage.setItem(
              "hotel_booking_event",
              JSON.stringify(bookingPayload),
            );
          }

          localStorage.removeItem("envision");
          navigate(`/loja/checkout-message-travel/${orderUuid}`);
        } else {
          notify("Pedido criado, mas sem ID retornado.", "warning");
          navigate("/loja/checkout-message-travel");
        }
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          "Erro ao finalizar reserva de hotel.";
        notify(errorMessage, "error");
        navigate("/loja/checkout-message-travel");
      } finally {
        setLoadingCheckout(false);
      }
      return;
    }

    let type = "CREDIT";

    if (effectiveMoneyToPay > 0 && pontosValue > 0) {
      type = "BOTH";
    } else if (effectiveMoneyToPay <= 0 && pontosValue > 0) {
      type = "POINTS";
    }

    const checkout = {
      totalAmount: effectiveMoneyToPay || dataCheckout.summary.total,
      customerData: {
        pagarmeId: null,
        customerUuid: user.uuid,
        createdAt: user.created_at
          ? new Date(user.created_at).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        firstName: user.nome,
        lastName: user.sobrenome,
        cpf: user.cpf,
        email: user.email,
        pagarmeId: null,
        phones: {
          number: user.telefone,
        },
        address: {
          addressUuid: addressShipping.uuid,
          streetName: addressShipping.address_line1,
          complement: addressShipping.address_line3,
          neighborhood: addressShipping.address_line2,
          number: addressShipping.number,
          cep: addressShipping.cep,
          city: addressShipping.city,
          state: addressShipping.state,
          reference: addressShipping.reference,
        },
      },
      paymentBRL: {
        type: type,
        amount: effectiveMoneyToPay,
        installments: installmentsSelected || 1,
        save: false,
        mainCard: false,
        cardUuid: null,
        gatewayCardKey: null,
      },
    };

    if (mainCard && mainCard.uuid) {
      checkout.paymentBRL.cardUuid = mainCard.uuid;
    } else if (mainCard && mainCard.hash) {
      checkout.paymentBRL.gatewayCardKey = mainCard.hash;
    }

    if (
      displayMode === "points" ||
      (displayMode === "both" && fatorFrete > 0 && pontosValue > 0)
    ) {
      const amountPoints = Math.round(pontosValue);

      checkout.paymentPoints = {
        fator: fatorFrete,
        amount: amountPoints || 0,
      };
    }

    const uuid = user.uuid;

    pedidosApi
      .post(`v2/checkout/finalizar-pedido/${channel}`, checkout)
      .then(async (response) => {
        const orderUuid = response?.data?.data?.orderUuid;
        if (orderUuid) {
          const authorizeOrder = await pedidosApi.post(
            `v1/pedidos/${channel}/authorization/` + orderUuid,
            {
              authorized: true,
            },
          );

          if (
            authorizeOrder?.data?.data?.status?.toLowerCase() ===
            ORDER_STATUS.DENIED
          ) {
            navigate(`/loja/ordernotapproved`);
            return;
          }

          const balance = await clientesApi.get(`customer/${user.cpf}/balance`);

          const userData = getCustomerFromMemory();
          if (userData) {
            userData.data.balance = {
              data: balance.data.data,
            };
            setCustomerInMemory(userData);

            updateUserData();
          }

          trackPurchaseMarketplaceItems(dataCheckout.cart?.items || [], {
            transactionId: orderUuid,
            value: parseFloat(dataCheckout.summary?.total || 0),
            shipping: parseFloat(dataCheckout.summary?.shipping || 0),
            coupon: dataCheckout.summary?.coupon?.code || dataCheckout.summary?.coupon?.name || "",
          });

          Object.keys(itemsCart).map(function (store) {
            itemsCart[store].map(function (product) {
              const sku = product.item?.sku ?? product.sku;
              const cep = addressShipping.cep;
              dispatch(removeItemCart({ sku, uuid, cep })).unwrap();
            });
          });
          navigate(`/loja/orderresumestatus/${orderUuid}`);
        }
      })
      .catch((error) => {
        const response = error?.response?.data || {
          message: "Não foi possível completar sua operação.",
        };
        navigate(`/loja/ordernotapproved`);
      })
      .finally((result) => {
        setUpdateUser(new Date());
      });
  }

  if (dataCheckout.length === 0) return <LoaderSmall />;

  if (loadingCheckout) return <LoaderSmall />;

  if (loading) return <LoaderSmall />;

  const getValueByDisplayMode = (product, displayMode, dataCheckout) => {
    const { price } = product;

    switch (displayMode) {
      case "money":
        return parseFloat(dataCheckout.summary?.total || 0);

      case "points":
        return parseInt(price?.points?.offer || 0, 10);

      case "both":
        return {
          money: parseFloat(dataCheckout.summary?.total || 0),
          points: parseInt(price?.points?.offer || 0, 10),
        };

      default:
        return 0;
    }
  };

  const handleOpenRegrasCupom = () => {
    trackResumoCompraEvent({ title: "confira-as-regras-do-cupom" });
    setRulesExpanded(true);
  };

  const handleCloseRegrasCupom = () => {
    trackResumoCompraEvent({ title: "fechar-modal" });
    setRulesExpanded(false);
  };

  const whoTab = (product, type, displayMode) => {
    const { price } = product;
    const BRL = price?.BRL;
    const SAFRA = price?.points;

    if (displayMode === "money") {
      return type === "dinheiro" && BRL?.offer > 0;
    }

    if (displayMode === "points") {
      return type === "pontos" && SAFRA?.offer > 0;
    }

    if (displayMode === "both") {
      return (
        (type === "dinheiro" && BRL?.offer > 0) ||
        (type === "pontos" && SAFRA?.offer > 0)
      );
    }

    return false;
  };

  return (
    <>
      <EmailRequiredModal
        show={showEmailRequired}
        onClose={() => setShowEmailRequired(false)}
        onRegisterEmail={() => {
          setShowEmailRequired(false);
          navigate("/loja/pj/myaccount/");
        }}
        onContinue={() => setShowEmailRequired(false)}
      />
      <InsufficientPointsModal
        show={showInsufficientPoints}
        onClose={() => setShowInsufficientPoints(false)}
        minPoints={minValue}
        userBalance={Math.trunc(user?.balance?.data || 0)}
      />
      <div className="wl-page">
        <CouponRulesModal open={open} setOpen={setOpen} couponRules={rules} />

        <Container>
          <TitleHead
            titleClass="my-4"
            label={isHotelCheckout ? "Resumo da reserva" : "Resumo da compra"}
          />

          {isHotelCheckout && hotelData && (
            <>
              <div id="hotelCard" className="mb-3">
                <Row className="mb-4">
                  <Col>
                    <p className="font-wl-500 text-md color-text-dark mb-0">
                      Quarto
                    </p>
                    <p className="text-sm text-muted mb-0">
                      {getHotelRoom()?.name || "(Nome do modelo do quarto)"}
                    </p>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <p className="text-sm text-muted mb-0">
                      {getHotelNights()} diária{getHotelNights() > 1 ? "s" : ""}
                    </p>
                  </Col>
                  <Col className="text-end">
                    <p className="text-sm color-text-dark mb-0">
                      {FormatPoints(getHotelDailyPoints())} pts
                    </p>
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col>
                    <p className="text-sm text-muted mb-0">Taxa</p>
                  </Col>
                  <Col className="text-end">
                    <p className="text-sm color-text-dark mb-0">
                      {FormatPoints(getHotelTaxPoints())} pts
                    </p>
                  </Col>
                </Row>
              </div>
            </>
          )}

          {!isHotelCheckout &&
            itemsCart &&
            Object.keys(itemsCart).map((item) => {
              const typeToFilter =
                displayMode === "points" ? "pontos" : "dinheiro";

              const brandItems = itemsCart[item].filter((product) =>
                whoTab(product, typeToFilter, displayMode),
              );
              const lastIndex = brandItems.length - 1;

              return (
                <React.Fragment key={item}>
                  <div id="productCard" className="mb-3">
                    <TitleBrand className="font-wl-500 mb-5 text-mlg color-text-dark">
                      {item}
                    </TitleBrand>
                    {brandItems.map((product, index) => (
                      <ProductRow
                        key={index}
                        item={item}
                        itemsCart={itemsCart}
                        lastIndex={lastIndex}
                        product={product}
                        index={index}
                        displayMode={displayMode}
                        checkout={dataCheckout}
                      />
                    ))}
                  </div>
                  <Line className="my-4" />
                </React.Fragment>
              );
            })}

          {!isHotelCheckout &&
            dataCheckout.summary?.coupon &&
            dataCheckout.summary?.discount > 0 && (
              <>
                <DiscountRow>
                  <span className="discount-label">DESCONTO</span>
                  <span className="discount-value">
                    {BrlFormatCurrency(dataCheckout.summary.discount)}
                  </span>
                </DiscountRow>
              </>
            )}

          <Line />
          <Row className="font-wl-700">
            <Col>
              <p className="color-text-dark text-mg"> Total do Pedido</p>
            </Col>
            <Col className="text-end">
              {isHotelCheckout && (
                <p className="font-wl-700 text-lg color-text-dark">
                  {FormatPoints(getHotelTotalPoints())} pts
                </p>
              )}
              {!isHotelCheckout && displayMode === "money" && (
                <p className="font-wl-700 text-lg color-text-dark">
                  {BrlFormatCurrency(dataCheckout.summary?.total || 0)}
                </p>
              )}
              {!isHotelCheckout && displayMode === "points" && (
                <p className="font-wl-700 text-lg color-text-dark">
                  {totalPointsWithDiscount
                    ? `${FormatPoints(totalPointsWithDiscount)} pts`
                    : "0 pts"}
                </p>
              )}
              {!isHotelCheckout && displayMode === "both" && (
                <p className="font-wl-700 text-lg color-text-dark">
                  {BrlFormatCurrency(dataCheckout.summary?.total || 0)}{" "}
                  <span className="text-muted">ou</span>{" "}
                  {totalPointsWithDiscount
                    ? `${FormatPoints(totalPointsWithDiscount)} pts`
                    : "0 pts"}
                </p>
              )}
            </Col>
          </Row>

          {!isHotelCheckout && (
            <Col className="d-flex flex-column mt-5">
              <Row className="coupon-custom">
                <Title className="color-text-dark font-wl-500 text-mlg">
                  Cupom de desconto
                </Title>
                <ContainerCupom>
                  <TextField
                    type="text"
                    fullWidth
                    placeholder="Insira o cupom"
                    onChange={(e) => setCoupon(e.target.value)}
                    value={coupon}
                    variant="standard"
                    disabled={isCouponApplied}
                  />
                </ContainerCupom>
              </Row>

              <Row className="d-flex align-items-center justify-content-center">
                {!isCouponApplied && isValidCoupon === null && (
                  <Button
                    type="button"
                    disabled={!coupon.length > 0}
                    className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                    style={{ width: 187, height: 30 }}
                    onClick={() => applyCoupon()}
                  >
                    {loadingCoupon ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                    ) : (
                      "APLICAR"
                    )}
                  </Button>
                )}

                {isCouponApplied && isValidCoupon === true && (
                  <Button
                    type="button"
                    className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                    style={{ width: 187, height: 30 }}
                    onClick={() => removeCoupon()}
                    disabled={loadingCoupon}
                  >
                    {loadingCoupon ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                    ) : (
                      "REMOVER"
                    )}
                  </Button>
                )}
              </Row>

              {isValidCoupon === true && dataCheckout.summary?.coupon && (
                <CouponSuccess>
                  <div className="coupon-title">
                    <FaRegCheckCircle size={18} />
                    <span>Cupom aplicado</span>
                  </div>

                  {dataCheckout.summary.coupon.description && (
                    <p className="coupon-message">
                      {dataCheckout.summary.coupon.description}
                    </p>
                  )}

                  {rules && (
                    <>
                      <button
                        className="coupon-rules-toggle"
                        onClick={rulesExpanded ? handleCloseRegrasCupom : handleOpenRegrasCupom}
                      >
                        <span>Confira as regras</span>
                        <span
                          className={`toggle-icon ${rulesExpanded ? "expanded" : ""}`}
                        >
                          <FaChevronDown size={14} />
                        </span>
                      </button>

                      {rulesExpanded && (
                        <div className="coupon-rules-content">{rules}</div>
                      )}
                    </>
                  )}
                </CouponSuccess>
              )}

              {isValidCoupon === false && (
                <>
                  <CouponError>
                    <div className="coupon-title">
                      <FaExclamationCircle size={18} />
                      <span>{errorTitle}</span>
                    </div>

                    <p className="coupon-message">{errorDescription}</p>

                    {errorCode === "COUPON_NOT_APPLICABLE" && rules && (
                      <>
                        <button
                          className="coupon-rules-toggle"
                          onClick={rulesExpanded ? handleCloseRegrasCupom : handleOpenRegrasCupom}
                        >
                          <span>Confira as regras</span>
                          <span
                            className={`toggle-icon ${rulesExpanded ? "expanded" : ""}`}
                          >
                            <FaChevronDown size={14} />
                          </span>
                        </button>

                        {rulesExpanded && (
                          <div className="coupon-rules-content">{rules}</div>
                        )}
                      </>
                    )}
                  </CouponError>

                  <Row className="d-flex align-items-center justify-content-center">
                    <Button
                      type="button"
                      className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                      style={{ width: 187, height: 30 }}
                      onClick={() => {
                        setCoupon("");
                        setIsValidCoupon(null);
                        setErrorCoupon("");
                        setErrorTitle("");
                        setErrorDescription("");
                        setErrorCode("");
                        if (rulesExpanded) {
                          handleCloseRegrasCupom();
                        }
                      }}
                    >
                      TENTAR NOVAMENTE
                    </Button>
                  </Row>
                </>
              )}
            </Col>
          )}

          <Row className="mt-4">
            {!isHotelCheckout && displayMode === "money" && (
              <Col className="d-flex flex-column mt-5">
                <Row className="coupon-custom">
                  <Title className="color-text-dark font-wl-600 text-mlg">
                    Cupom de desconto
                  </Title>
                  <ContainerCupom>
                    <TextField
                      type="text"
                      fullWidth
                      placeholder="Insira o cupom"
                      onChange={(e) => setCoupon(e.target.value)}
                      value={coupon}
                      variant="standard"
                      disabled={isCouponApplied}
                    />
                  </ContainerCupom>
                  {errorCoupon && (
                    <span className="text-danger text-sm">{errorCoupon}</span>
                  )}
                </Row>
                <Row className="d-flex align-items-center justify-content-center">
                  {!dataCheckout.summary?.coupon ? (
                    <Button
                      type="button"
                      disabled={!coupon.length > 0}
                      className="btn btn-secondary btn-default-wl w-50 m-3"
                      onClick={() => applyCoupon()}
                    >
                      {loadingCoupon ? (
                        <span
                          className="spinner-border spinner-border-sm "
                          role="status"
                        />
                      ) : (
                        "APLICAR"
                      )}
                    </Button>
                  ) : (
                    <Button
                      type="button"
                      disabled={!coupon.length > 0 || loadingCoupon}
                      className="btn btn-secondary btn-default-wl w-50 m-3"
                      onClick={() => removeCoupon()}
                    >
                      {loadingCoupon ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                      ) : (
                        "REMOVER"
                      )}
                    </Button>
                  )}
                </Row>
                <Row>
                  <p className="text-center font-wl-700 text-lg mt-3">
                    {BrlFormatCurrency(dinheiroValue)}
                  </p>
                </Row>
              </Col>
            )}

            {(isHotelCheckout ||
              displayMode === "both" ||
              displayMode === "points") && (
              <BoxSlider>
                <div className="slider">
                  <p className="color-text-dark font-wl-600 text-mlg">
                    Formas de pagamento
                  </p>
                  <Container className="mt-4">
                    {isHotelCheckout && hotelData ? (
                      <SliderCheckout
                        totalPoints={getHotelTotalPoints()}
                        totalMoney={getHotelTotalMoney()}
                        userBalance={Math.trunc(user?.balance?.data || 0)}
                        minPoints={minValue}
                        onChange={(values) => {
                          setPontosValue(values.pointsValue);
                          setDinheiroValue(roundCurrency(values.moneyValue));
                          setSliderValue((values.sliderValue / 100) * 100);
                          handlePaymentInfoChange(values.moneyValue, values.pointsValue);
                        }}
                        disabled={false}
                        factor={
                          getHotelTotalMoney() > 0
                            ? getHotelTotalPoints() / getHotelTotalMoney()
                            : 1
                        }
                      />
                    ) : isCouponApplied && dataCheckout.summary?.coupon ? (
                      <SliderCheckoutCoupon
                        totalPoints={totalPoints}
                        totalMoney={
                          parseFloat(dataCheckout.summary?.total || 0) +
                          parseFloat(dataCheckout.summary?.discount || 0)
                        }
                        couponDiscount={parseFloat(
                          dataCheckout.summary?.discount || 0,
                        )}
                        userBalance={Math.trunc(user?.balance?.data || 0)}
                        minPoints={minValue}
                        onChange={(values) => {
                          setPontosValue(values.pointsValue);
                          setDinheiroValue(roundCurrency(values.moneyValue));
                          setCouponMoneyToPay(values.moneyToPay || 0);
                          handlePaymentInfoChange(values.moneyValue, values.pointsValue);
                        }}
                        disabled={false}
                        isCouponApplied={true}
                        factor={fatorFrete > 0 ? 1 / fatorFrete : 1}
                      />
                    ) : (
                      <SliderCheckout
                        totalPoints={totalPoints}
                        totalMoney={parseFloat(
                          dataCheckout.summary?.total || 0,
                        )}
                        userBalance={Math.trunc(user?.balance?.data || 0)}
                        minPoints={minValue}
                        onChange={(values) => {
                          setPontosValue(values.pointsValue);
                          setDinheiroValue(roundCurrency(values.moneyValue));
                          setSliderValue((values.sliderValue / 100) * 100);
                          handlePaymentInfoChange(values.moneyValue, values.pointsValue);
                        }}
                        disabled={aplicouCupon}
                        factor={fatorFrete > 0 ? 1 / fatorFrete : 1}
                      />
                    )}
                  </Container>
                </div>
              </BoxSlider>
            )}
          </Row>
          {!isMoneyDisabled && (
            <Row
              className={`mt-4 mb-3 ${disableMoneyPayment || effectiveMoneyToPay <= 0 ? "disable" : ""}`}
            >
              <Col>
                <CreditCardList
                  cards={cards}
                  closeNewCard={closeNewCard}
                  openNewCard={() => setBoxNewCard(true)}
                  title="Formas de pagamento"
                  onSelected={(value) => selecionarParcela(value)}
                  onSaveCard={(values, card_hash) =>
                    saveNewCard(values, card_hash)
                  }
                  onRefreshCards={() => setRefreshCards(new Date())}
                  Loading={isLoading}
                />
              </Col>
            </Row>
          )}
          {!isMoneyDisabled && (
            <Row
              className={`mt-5 ${disableMoneyPayment || effectiveMoneyToPay <= 0 ? "disable" : ""}`}
            >
              <Col>
                <Form.Group>
                  <Title
                    className="font-wl-500 text-mg"
                    style={{
                      color: whitelabel?.text_primary_color || "#333333",
                    }}
                  >
                    Parcelamento
                  </Title>
                  <TextField
                    select
                    fullWidth
                    placeholder="Selecione as parcelas"
                    onChange={(e) => setInstallmentsSelected(e.target.value)}
                    disabled={
                      disableMoneyPayment === "disable" ||
                      effectiveMoneyToPay <= 0
                    }
                    variant="standard"
                    sx={{
                      "& .MuiInputBase-root": {
                        color: whitelabel?.text_primary_color,
                      },
                      "& .MuiInput-underline:before": {
                        borderBottomColor: whitelabel?.text_primary_color,
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottomColor: whitelabel?.text_primary_color,
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: whitelabel?.text_primary_color,
                      },
                      "& .MuiInputBase-input": {
                        color: whitelabel?.text_primary_color,
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: whitelabel?.text_primary_color,
                        opacity: 0.7,
                      },
                    }}
                    SelectProps={{
                      native: true,
                    }}
                    style={{
                      color: whitelabel?.text_primary_color,
                    }}
                  >
                    <option
                      value=""
                      style={{ color: whitelabel?.text_primary_color }}
                    >
                      Selecione as parcelas
                    </option>
                    {installments.map((item, index) => (
                      <option
                        key={index}
                        value={item.installmentNumber}
                        style={{ color: whitelabel?.text_primary_color }}
                      >
                        {item.installmentNumber} x{" "}
                        {BrlFormatCurrency(item.installmentPrice)}
                        {item.interest > 0
                          ? ` (juros ${item.interest / 100}%)`
                          : "(sem juros)"}
                      </option>
                    ))}
                  </TextField>
                </Form.Group>
              </Col>
            </Row>
          )}
        </Container>

        {isHotelCheckout && (
          <Container className="mt-4 mb-3">
            <Form.Check
              type="checkbox"
              id="hotel-terms-checkbox"
              checked={hotelTermsAccepted}
              onChange={(e) => setHotelTermsAccepted(e.target.checked)}
              label={
                <span className="text-xs">
                  Declaro que li o{" "}
                  <button
                    type="button"
                    onClick={() => setHotelRulesModalOpen(true)}
                    style={{
                      textDecoration: "underline",
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "inherit",
                      cursor: "pointer",
                    }}
                  >
                    regulamento
                  </button>{" "}
                  e estou de acordo com os termos das tarifas e serviços
                  oferecidos.
                </span>
              }
            />
          </Container>
        )}

        <ModalApp
          show={hotelRulesModalOpen}
          handleModal={() => setHotelRulesModalOpen(false)}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "70vh",
            }}
          >
            <h5
              className="text-center font-wl-600"
              style={{
                padding: "0 16px 16px 16px",
                margin: 0,
                borderBottom: "1px solid #eee",
                flexShrink: 0,
              }}
            >
              TERMOS E CONDIÇÕES DE USO HOTÉIS 
            </h5>
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "16px",
                textAlign: "left",
              }}
            >
              <h5
                className="text-center font-wl-600"
                style={{
                  padding: "0 16px 8px 16px",
                  margin: 0,
                  borderBottom: "1px solid #eee",
                  flexShrink: 0,
                }}
              >
                1. HOSPEDAGEM 
              </h5>
              <p className="text-sm mb-3">
                <strong>1.</strong> Após o resgate, o envio das informações relativas ao serviço e a emissão da reserva (voucher) se dará 
                por meio do e-mail informado pelo participante em seu cadastro no programa, sendo de sua 
                exclusiva responsabilidade a veracidade das informações fornecidas. O programa não se 
                responsabiliza pelo não recebimento do e-mail pelo participante. 
              </p>
              <p className="text-sm mb-3">
                <strong>1.1</strong> Caso o participante não venha a receber o e-mail com a informação de seu resgate/voucher no 
                prazo de até 24 (vinte e quatro) horas contadas do resgate, deverá entrar em contato com a 
                Central de Atendimento do Programa.
                ainda, um sofá-cama.
              </p>
              <p className="text-sm mb-3">
                <strong>1.2</strong> O Cliente deverá preencher todos os campos com dados exatos para poder realizar reservas 
                válidas e se responsabiliza pela veracidade, exatidão, vigência e autenticidade dos dados 
                inseridos. Os dados deverão coincidir de forma exata com a documentação de viagem necessária 
                para o check-in. O Programa não se responsabiliza por eventuais erros de digitação do Cliente.
              </p>
              <p className="text-sm mb-3">
                <strong>1.3</strong> O nome do hotel e o tipo de acomodação adquirida constam da respectiva ordem de serviço 
                (voucher), a qual deverá ser apresentada no estabelecimento comercial no momento do check
                in.
              </p>
              <p className="text-sm mb-3">
                <strong>1.4</strong> O hotel poderá oferecer diferentes acomodações: o apartamento duplo poderá ter 02 (duas) 
                camas separadas ou 01 (uma) de casal; os apartamentos triplos ou quádruplos poderão ter (i) 02 
                (duas) camas de casal ou (ii) 02 (duas) camas de solteiro e 02 (duas) camas articuladas, ou, ainda, 
                um sofá-cama.  
              </p>
              <p className="text-sm mb-3">
                <strong>1.5</strong> A entrada (check-in) geralmente é autorizada a partir das 15 (quinze) horas. A entrada em horário 
                anterior às 15 (quinze) horas estará condicionada à disponibilidade e aprovação do hotel, 
                cabendo ao Cliente consultar o estabelecimento, não podendo o Programa ser responsabilizado 
                em caso de impossibilidade de acomodação em horário anterior ao mencionado neste item.
              </p>
              <p className="text-sm mb-3">
                <strong>1.6</strong> A saída (check-out) normalmente é realizada às 10 (dez) horas, cabendo ao Cliente verificar com 
                o estabelecimento a possibilidade de extensão da estadia.
              </p>
              <p className="text-sm mb-3">
                <strong>1.7</strong> Os horários de check-in e check-out podem variar dependendo do regulamento de cada hotel, 
                cabendo ao Cliente pagar diretamente ao estabelecimento eventuais valores referentes à 
                utilização de diárias extras. 
              </p>
              <p className="text-sm mb-3">
                <strong>1.8</strong> Os hotéis poderão, a seu critério e sob sua responsabilidade, solicitar o cartão de crédito do 
                Cliente para caucionar eventuais despesas. Caberá ao Cliente verificar junto ao hotel acerca de 
                eventual valor a ser caucionado durante sua estadia, bem como a disponibilidade de limite no 
                seu cartão de crédito. 
              </p>
              <p className="text-sm mb-3">
                <strong>1.9</strong> Na hipótese do Cliente não realizar o check-in até às 18 (dezoito) horas, horário local do hotel, 
                este poderá cancelar integralmente a reserva pré-existente. O apartamento reservado será 
                devolvido ao inventário do hotel automaticamente, podendo ser revendido a critério do hotel ou 
                fornecedor sem crédito para o Cliente. Havendo necessidade, o cliente pode informar-se sobre a 
                chegada ao hotel após às 18hrs, diretamente com o estabelecimento. 
              </p>
              <p className="text-sm mb-3">
                <strong>1.10</strong> Devido à política de alguns setores de reservas de hotéis, os nomes indicados na reserva 
                somente são enviados para o estabelecimento hoteleiro na semana de seu check-in. Por isso, é 
                possível que o quarto esteja reservado, porém o nome ainda não esteja inserido no inventário do 
                hotel.
              </p>
              <p className="text-sm mb-3">
                <strong>1.11</strong> Se o Cliente quiser reservar mais de um quarto, deverá utilizar nomes diferentes para cada 
                quarto, pois reservas duplicadas, ou seja, com o mesmo nome, poderão ser canceladas pelo 
                hotel. 
              </p>
              <p className="text-sm mb-3">
                <strong>1.12</strong> Em hotéis, o café da manhã e/ou as refeições, quando inclusas nas diárias, são contratados 
                com os hotéis e/ou restaurante locais, sendo o menu fixo, com bebidas não inclusas e horários pré
                estabelecidos. Se incluso, o regime de alimentação estará indicado no voucher. Crianças não 
                pagantes que compartilham o apartamento com adultos, utilizando o plano familiar do hotel, não 
                têm direito a café-da-manhã e/ou refeições na forma de cortesia. 
              </p>
              <p className="text-sm mb-3">
                <strong>1.13</strong> As informações específicas da hospedagem, como nome, localização, categoria, fotos e 
                serviços incluídos são fornecidas pelos próprios estabelecimentos de hospedagem, sendo de inteira 
                responsabilidade destes. O Programa não poderá ser responsabilizado por eventuais discrepâncias 
                havidas entre os dados informados pelo estabelecimento, imagens e a situação real e localização dos 
                hotéis.
              </p>
              <p className="text-sm mb-3">
                <strong>1.14</strong> É recomendado que, em caso de dúvidas, o Cliente tome conhecimento dos comentários e 
                avaliações de outros hóspedes para verificar se a hospedagem se ajusta às suas preferências e 
                necessidades. O Programa não é e não deve ser interpretado como um promotor da qualidade, do 
                nível de serviço e/ou da qualificação ou classificação de qualquer hospedagem. 
              </p>
              <p className="text-sm mb-3">
                <strong>1.15</strong> No momento da saída do hotel, o Cliente deverá verificar com atenção a fatura apresentada. 
                O voucher do Programa deverá ter sido aplicado para pagamento dos serviços nele discriminados. E, 
                no cartão de crédito do Cliente, deverá ser debitado somente o valor de despesas extras e adicionais.
              </p>
              <p className="text-sm mb-3">
                <strong>1.16</strong> É de inteira responsabilidade do Cliente verificar a ocorrência de débitos indevidos em seu 
                cartão de crédito ou qualquer outra situação adversa, cuja resolução deverá ser resolvida 
                diretamente com a hospedagem e/ou com a administradora do cartão de crédito. 
              </p>
              <h5
                className="text-center font-wl-600"
                style={{
                  padding: "0 16px 8px 16px",
                  margin: 0,
                  borderBottom: "1px solid #eee",
                  flexShrink: 0,
                }}
              >
                2. ALTERAÇÕES DE RESERVAS  
              </h5>
              <p className="text-sm mb-3">
                <strong>2.1</strong> As reservas de hotéis realizadas por meio do programa estão sujeitas às políticas de alteração 
                estabelecidas pelo hotel, rede hoteleira ou fornecedor contratado, podendo variar de acordo com o tipo de 
                tarifa, período da estadia, destino e condições promocionais. 
              </p>
              <p className="text-sm mb-3">
                <strong>2.2</strong> As solicitações de alteração (datas, nome do hóspede, tipo de acomodação ou outras condições) estão 
                sujeitas à disponibilidade e aprovação do hotel no momento da solicitação.
              </p>
              <p className="text-sm mb-3">
                <strong>2.3</strong> Alterações podem implicar reajuste de valores, cobrança de diferenças tarifárias e/ou aplicação de taxas 
                adicionais, conforme política vigente do hotel.
              </p>
              <h5
                className="text-center font-wl-600"
                style={{
                  padding: "0 16px 8px 16px",
                  margin: 0,
                  borderBottom: "1px solid #eee",
                  flexShrink: 0,
                }}
              >
                3. CANCELAMENTO DE RESERVAS
              </h5>
              <p className="text-sm mb-3">
                <strong>3.1</strong> As reservas de hotéis realizadas por meio do programa estão sujeitas às políticas de cancelamento 
                estabelecidas pelo hotel, rede hoteleira ou fornecedor contratado, podendo variar de acordo com o tipo de 
                tarifa, período da estadia, destino e condições promocionais. 
              </p>
              <p className="text-sm mb-3">
                <strong>3.2</strong> O cancelamento das reservas deverá respeitar o prazo e as condições definidos pelo hotel, informados 
                no momento da confirmação da reserva.
              </p>
              <p className="text-sm mb-3">
                <strong>3.3</strong> Cancelamentos realizados dentro do prazo permitido poderão estar sujeitos à cobrança de taxas 
                administrativas ou multas, conforme política do fornecedor. 
              </p>
              <p className="text-sm mb-3">
                <strong>3.4</strong> Cancelamentos efetuados fora do prazo, bem como no-show (não comparecimento), poderão resultar 
                na cobrança integral da estadia, sem direito a reembolso.
              </p>
              <p className="text-sm mb-3">
                <strong>3.5</strong> Em tarifas não reembolsáveis, não será permitido cancelamento ou reembolso, independentemente do 
                motivo. 
              </p>
              <h5
                className="text-center font-wl-600"
                style={{
                  padding: "0 16px 8px 16px",
                  margin: 0,
                  borderBottom: "1px solid #eee",
                  flexShrink: 0,
                }}
              >
                4. PRAZOS
              </h5>
              <p className="text-sm mb-3">
                <strong>4.1</strong> Somente serão aceitas solicitações de cancelamento ou alteração de pedidos já emitidos caso o cliente 
                o faça com no mínimo 72 horas de antecedência do embarque.
              </p>
              <p className="text-sm mb-3">
                <strong>4.2</strong> Recomenda-se que o participante do programa verifique atentamente as condições específicas antes da 
                confirmação da reserva. 
              </p>
              <h5
                className="text-center font-wl-600"
                style={{
                  padding: "0 16px 8px 16px",
                  margin: 0,
                  borderBottom: "1px solid #eee",
                  flexShrink: 0,
                }}
              >
                5. REEMBOLSO DE PONTOS 
              </h5>
              <p className="text-sm mb-3">
                <strong>5.1</strong> Quando aplicável, o reembolso de pontos será realizado exclusivamente na conta do participante titular 
                da reserva, respeitando as regras do Programa e as políticas do fornecedor. 
              </p>
              <p className="text-sm mb-3">
                <strong>5.2</strong> O prazo para reembolso de pontos, quando autorizado, seguirá conforme a política geral do Programa a 
                partir da confirmação do cancelamento pelo fornecedor.  
              </p>
              <p className="text-sm mb-3">
                <strong>5.3</strong> Pontos reembolsados não terão validade estendida, permanecendo sujeitos às regras originais de 
                expiração do Programa.  
              </p>
              <h5
                className="text-center font-wl-600"
                style={{
                  padding: "0 16px 8px 16px",
                  margin: 0,
                  borderBottom: "1px solid #eee",
                  flexShrink: 0,
                }}
              >
                6. RESPONSABILIDADE 
              </h5>
              <p className="text-sm mb-3">
                <strong>6.1</strong> O Programa não se responsabiliza por:
              </p>
              <p className="text-sm mb-3">
                <strong>.</strong> Alterações unilaterais das políticas dos hotéis;
              </p>
              <p className="text-sm mb-3">
                <strong>.</strong> Indisponibilidade de acomodações; 
              </p>
              <p className="text-sm mb-3">
                <strong>.</strong> Serviços não prestados pelo hotel; 
              </p>
              <p className="text-sm mb-3">
                <strong>.</strong> Multas, taxas ou penalidades aplicadas pelo fornecedor.
              </p>
              <h5
                className="text-center font-wl-600"
                style={{
                  padding: "0 16px 8px 16px",
                  margin: 0,
                  borderBottom: "1px solid #eee",
                  flexShrink: 0,
                }}
              >
                7. DISPOSIÇÕES GERAIS
              </h5>
              <p className="text-sm mb-3">
                <strong>7.1</strong> O programa atua como intermediador da reserva, não sendo responsável por políticas definidas pelos 
                hotéis ou fornecedores.
              </p>
              <p className="text-sm mb-3">
                <strong>7.2</strong> O resgate de pontos para reservas de hotéis implica a aceitação integral e irrestrita dos termos deste 
                regulamento, bem como das políticas específicas do hotel ou fornecedor parceiro.
              </p>
            </div>
            <div
              className="text-center"
              style={{
                padding: "16px",
                borderTop: "1px solid #eee",
                flexShrink: 0,
              }}
            >
              <Button
                type="button"
                className="btn-default-wl text-xxs font-wl-700"
                onClick={() => setHotelRulesModalOpen(false)}
                style={{ minWidth: "150px" }}
              >
                FECHAR
              </Button>
            </div>
          </div>
        </ModalApp>

        <Footer>
          <Button
            type="button"
            onClick={() => HandleFinished()}
            className="btn-default-wl mt-5 text-xxs font-wl-700"
            disabled={!hasEmail || (isHotelCheckout && !hotelTermsAccepted)}
          >
            {isHotelCheckout ? "FINALIZAR RESGATE" : "FINALIZAR COMPRA"}
          </Button>
        </Footer>
      </div>
    </>
  );
}
